export default __webpack_public_path__ + "static/media/vimeo_white.440b3eb3.svg";